import { kategorier } from './kategorier'
import { lenker } from './lenker'
import { landingsside } from './landingsside'
import { footer } from './footer'
import { beskrivelse } from './beskrivelse'
import { baseUrl, currentRoute } from './router'

export function hydrateStores(props) {
  const { data } = props
  baseUrl.set(props.baseUrl)
  if (data.route) {
    currentRoute.set(data.route)
  }
  const populateLenker = createPopulater(data.lenker)
  lenker.set(data.lenker)
  kategorier.set(
    data.kategorier.map((k) => ({
      ...k,
      lenker: populateLenker(k.lenker),
    }))
  )
  landingsside.set({
    lenker: populateLenker(data.landingsside.lenker),
    topplenker: populateLenker(data.landingsside.topplenker),
  })
  footer.set(data.footer)
  beskrivelse.set(data.beskrivelse)
}
/* eslint-disable */
function createPopulater(lenker = []) {
  const idMap = {}
  for (const lenke of lenker) {
    idMap[lenke.id] = lenke
  }

  return function populate(lenker) {
    return lenker.map(({ id }) => idMap[id])
  }
}
/* eslint-enable */
